import { differenceInDays } from 'date-fns';
import { ClaimStatus } from '../../parcel-finder/claims/types';
import { ListClaim } from '../../../api/types';

export enum CustomerActionType {
  NONE = 'none',
  TAKE_CUSTOMER_ACTION = 'take_customer_action',
  VIEW_DECLINED_REASON = 'view_declined_reason',
  DISPUTE_DECLINED_REASON = 'dispute_declined_reason',
}

export function getActionTypeForClaim(claim?: ListClaim | null): CustomerActionType {
  const { status, rejectedAt, isDeclinedPastTakeActionDeadline = false, submittedAt = null, isNon7sShipment } =
    claim || {};

  if (status === ClaimStatus.ACTION_REQUIRED) {
    return CustomerActionType.TAKE_CUSTOMER_ACTION;
  }

  if (status === ClaimStatus.DECLINED) {
    return rejectedAt &&
      isDisputePossible(new Date(rejectedAt), isDeclinedPastTakeActionDeadline, submittedAt, isNon7sShipment)
      ? CustomerActionType.DISPUTE_DECLINED_REASON
      : CustomerActionType.VIEW_DECLINED_REASON;
  }

  return CustomerActionType.NONE;
}

const daysToDispute = 14;

export function getDaysLeftToDispute(rejectedAt: string | Date): number {
  const diff = differenceInDays(Date.now(), new Date(rejectedAt));
  return daysToDispute - diff;
}

function isDisputePossible(
  rejectedAt: string | Date,
  isDeclinedPastTakeActionDeadline: boolean,
  submittedAt: string | null,
  isNon7sShipment?: boolean | null
): boolean {
  if (isNon7sShipment) {
    return true;
  }

  if (isDeclinedPastTakeActionDeadline) {
    return false;
  }

  if (!submittedAt) {
    return false;
  }

  const daysLeftToDispute = getDaysLeftToDispute(rejectedAt);

  return daysLeftToDispute > 0;
}
